export default "__VITE_ASSET__4pGH1upS__"